<template>
  <v-card
    ref="refComponent "
    class="ma-0 px-1 position-relative"
    :class="{'fullscreen' : fullscreen}"
    style="position: relative;"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="40"
    >
      <v-toolbar-title class="me-5">
        {{ $t(type) }}
      </v-toolbar-title>
      <v-tabs
        v-show="!isMobile"
        v-model="tab"
        style="width: 400px"
      >
        <v-tab>
          {{ $t('public-information') }}
        </v-tab>
        <v-tab>{{ $t('addtional-information') }}</v-tab>
      </v-tabs>
      <v-spacer />
      <!--      <v-btn-->
      <!--        class="mx-4 mt-2"-->
      <!--        height="32"-->
      <!--        style="background-color: #009688 !important;"-->
      <!--        @click="prevInvoice"-->
      <!--      >-->
      <!--        {{ $t('prevInvoice') }}-->
      <!--      </v-btn>-->
      <!--      <v-btn-->
      <!--        class="mx-4 mt-2"-->
      <!--        height="32"-->
      <!--        style="background-color: #009688 !important;"-->
      <!--        :disabled="(lastId && lastId >= currentId ? false : true)"-->
      <!--        @click="nextInvoice"-->
      <!--      >-->
      <!--        {{ $t('nextInvoice') }}-->
      <!--      </v-btn>-->
      <!--      <v-btn-->
      <!--        v-shortkey="['/']"-->
      <!--        class="mx-4 mt-2"-->
      <!--        height="32"-->
      <!--        style="background-color: #AD1457 !important;"-->
      <!--        @shortkey="otherProduct"-->
      <!--        @click="otherProduct"-->
      <!--      >-->
      <!--        {{ $t('otherProduct') }} (/)-->
      <!--      </v-btn>-->
      <!--      <v-btn-->
      <!--        v-shortkey="['f8']"-->
      <!--        color="blue"-->
      <!--        class="mx-4 mt-2"-->
      <!--        height="32"-->
      <!--        style="background-color: #607D8B !important;"-->
      <!--        @shortkey="addProductDialog = true"-->
      <!--        @click="addProductDialog = true"-->
      <!--      >-->
      <!--        {{ $t('defineProduct') }} (f8)-->
      <!--      </v-btn>-->
      <!--      <v-btn-->
      <!--        color="primary"-->
      <!--        class="mx-4 mt-2"-->
      <!--        height="32"-->
      <!--        style="background-color: #818181 !important;"-->
      <!--        @click="callInvoiceById($event)"-->
      <!--      >-->
      <!--        {{ $t('searchInvoice') }}-->
      <!--      </v-btn>-->
      <!--      <div-->
      <!--        v-if="!isMobile"-->
      <!--        style="width: 200px"-->
      <!--      >-->
      <!--        <v-text-field-->
      <!--          v-model="numberForEdit"-->
      <!--          height="30"-->
      <!--          dense-->
      <!--          class="mb-3 me-3 mt-1"-->
      <!--          hide-details-->
      <!--          outlined-->
      <!--          type="number"-->
      <!--          clearable-->
      <!--          :label="$t('invoiceNumber')"-->
      <!--          @click:clear="clearableForm"-->
      <!--          @focus="focusEvent"-->
      <!--        />-->
      <!--      </div>-->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            width="35"
            class="float-left"
            v-on="on"
            @click="openWindowsKeyboard"
          >
            <v-icon
              color="primary"
              style="font-size: 30px"
            >
              mdi-keyboard-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('keyboard') }} (f10)</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            width="35"
            class="float-left"
            v-on="on"
            @click="openCalculator"
          >
            <v-icon
              color="primary"
              style="font-size: 28px"
            >
              mdi-calculator
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('calculator') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-shortkey="['f10']"
            v-bind="attrs"
            icon
            width="35"
            class="float-left"
            v-on="on"
            @shortkey="fullScreenFunc"
            @click="fullScreenFunc"
          >
            <v-icon
              color="primary"
              style="font-size: 30px"
            >
              {{ (!fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit') }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('fullscreen') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!isMobile && !id"
            v-bind="attrs"
            icon
            width="35"
            class="float-left"
            v-on="on"
            @click="getAllProductsOffline(type)"
          >
            <v-icon
              color="green"
              style="font-size: 30px"
            >
              mdi-sync
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('syncData') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            width="35"
            v-on="on"
            @click="goTo( type + 'List' )"
          >
            <v-icon
              color="primary"
              style="font-size: 30px"
            >
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('list') }} {{ $t(type) }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            width="35"
            v-on="on"
            @click="configDialog = true"
          >
            <v-icon
              color="primary"
              style="font-size: 26px"
            >
              mdi-cog-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('setting') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            width="35"
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 30px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render || loading"
      :indeterminate="!render || loading"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-tabs
        v-show="isMobile"
        v-model="tab"
      >
        <v-tab>
          {{ $t('public-information') }}
        </v-tab>
        <v-tab>{{ $t('addtional-information') }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-container
            class="py-0 px-1"
            fluid
          >
            <v-row class="mx-0">
              <v-col
                v-show="bodyStatus == false || !isMobile"
                cols="12"
                md="5"
                sm="5"
                class="px-0 pb-0"
              >
                <products
                  ref="productCategoryRef"
                  v-model="items"
                  :data="JSON.stringify({entrepot : (entrepot ? entrepot.id : null)})"
                  :item-count="(items ? items.length : 0)"
                  :height-prop="tableHeightInvoice"
                  :offline-prop="offline"
                  :type-prop="type"
                  :scale-prop="scale"
                  @append="append"
                  @blur="setFocus"
                  @setOffline="setOffline"
                />
              </v-col>
              <v-col
                v-show="bodyStatus == true || !isMobile"
                cols="12"
                md="6"
                sm="6"
                class="ps-0"
              >
                <v-row class="my-2 mx-0 px-0">
                  <v-col
                    cols="6"
                    class="py-1 px-1"
                    md="2"
                  >
                    <v-text-field
                      v-model="number"
                      height="20"
                      dense
                      :rules="[v => !!v || $t('is-required')]"
                      outlined
                      class="mb-3 dense"
                      clearable
                      :label="$t('number')"
                      @blur="getInvoiceNumber"
                      @focus="focusEvent"
                    />
                  </v-col>
                  <v-col
                    class="px-1 xs py-1"
                    cols="6"
                    :class="{'mb-3' : isMobile}"
                    md="4"
                  >
                    <autocomplete
                      ref="refAccount"
                      v-model="account"
                      title="account"
                      :type="(offline ? 'getAllPersonOffline' : 'person')"
                      :offline="offline"
                      :set-offline="offline"
                      :new-btn="true"
                      :rules="[v => !!v || $t('is-required')]"
                      :value="account"
                    />
                  </v-col>
                  <v-col
                    class="px-1 xs py-1"
                    :class="{'mb-3' : isMobile}"
                    cols="6"
                    md="3"
                  >
                    <autocomplete
                      ref="refEntrepot"
                      v-model="entrepot"
                      title="entrepot"
                      type="entrepot"
                      :set-init="(id ? false : false)"
                      :new-btn="true"
                      :value="entrepot"
                      :offline="offline"
                      :set-offline="offline"
                      @input="checkProductsCount"
                    />
                  </v-col>
                  <v-col
                    class="py-1 px-1"
                    cols="6"
                    md="3"
                    :class="{'mb-3' : isMobile}"
                  >
                    <template>
                      <v-text-field
                        id="from"
                        v-model="date"
                        :label="$t('date')"
                        :rules="[v => !!v || $t('is-required')]"
                        clear-icon="flaticon2-close-cross"
                        outlined
                        hide-details
                        dense
                        clearable
                      />
                      <date-picker
                        v-model="date"
                        element="from"
                        :locale="$store.state.date_locale"
                        :format="$store.state.date_format"
                        auto-submit
                        :min="$store.state.startDate"
                        :max="$store.state.endDate"
                        :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                        @close="setDate"
                      />
                    </template>
                  </v-col>
                  <v-col
                    v-show="false"
                    cols="12"
                    sm="2"
                    md="2"
                    :class="{'mb-3' : isMobile}"
                    class="py-1 px-1"
                  >
                    <aicomplete
                      v-model="branch"
                      title="branch"
                      type="branch"
                      :set-init="true"
                      :val="branch"
                      :offline="offline"
                      :set-offline="offline"
                      :new-btn="true"
                    />
                  </v-col>
                </v-row>
                <v-row class="my-2 mt-6 mx-0 px-0">
                  <v-col
                    class="px-0 py-0 border-datatable"
                  >
                    <v-row class="mx-0">
                      <v-col
                        ref="refScroll"
                        cols="12"
                        class="my-0 pa-0"
                        :style="{height: (isMobile ? tableHeightInvoice + 65 : tableHeightInvoice + 70) + 'px'}"
                        style="zoom:0.9;overflow-y: scroll;border-top: 1px solid #e3e3e3;border-bottom: 1px solid #e3e3e3;border-right: 1px solid #e3e3e3;min-height: 300px;"
                      >
                        <invoice-items
                          ref="refInvoiceItems"
                          v-model="items"
                          :items-prop="items"
                          :decimal="decimal"
                          :currency="currency"
                          :type="type"
                          :offline="offline"
                          :scale="scale"
                          :weight="weight"
                          @calc="calcSum"
                          @callrefbodyhight="setRefBody"
                          @setinputFocus="setFocus"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="mx-0">
                      <v-col
                        cols="12"
                        style="zoom:0.9"
                        class="mb-4 pa-0"
                      >
                        <!--v-simple-table-->
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                cols="12"
                md="1"
                sm="1"
                class="px-0"
              >
                <div
                  v-if="!isMobile"
                  style="width: 100%"
                >
                  <v-text-field
                    v-model="numberForEdit"
                    height="20"
                    dense
                    class="mb-3 mx-0 mt-3"
                    hide-details
                    outlined
                    type="number"
                    clearable
                    :label="$t('searchInvoice')"
                    @click:clear="clearableForm"
                    @focus="focusEvent"
                  />
                </div>
                <v-btn
                  color="primary"
                  class="mx-0 mt-2"
                  height="32"
                  style="background-color: #818181 !important;width: 100%"
                  @click="callInvoiceById($event)"
                >
                  {{ $t('searchInvoice') }}
                </v-btn>
                <v-btn
                  class="mx-0 mt-2"
                  height="32"
                  style="background-color: #009688 !important;width: 100%"
                  block
                  @click="prevInvoice"
                >
                  {{ $t('prevInvoice') }}
                </v-btn>
                <v-btn
                  class="mx-0 mt-2"
                  height="32"
                  style="background-color: #009688 !important;width: 100%"
                  :disabled="(lastId && lastId >= currentId ? false : true)"
                  @click="nextInvoice"
                >
                  {{ $t('nextInvoice') }}
                </v-btn>
                <v-btn
                  v-shortkey="['/']"
                  class="mx-0 mt-6"
                  height="32"
                  style="background-color: #AD1457 !important;width: 100%"
                  @shortkey="otherProduct"
                  @click="otherProduct"
                >
                  {{ $t('otherProduct') }} (/)
                </v-btn>
                <v-btn
                  v-shortkey="['f8']"
                  color="blue"
                  class="mx-0 mt-2"
                  height="32"
                  style="background-color: #607D8B !important;width: 100%"
                  @shortkey="addProductDialog = true"
                  @click="addProductDialog = true"
                >
                  {{ $t('defineProduct') }} (f8)
                </v-btn>
              </v-col>
            </v-row>
            <!--cach invoice-->
            <v-container 
              class="pa-2 ma-0 fixed-bottom-payment"
            >
              <v-container class="pa-0 d-flex align-center gap-2">
                <div>
                  <v-container class="pa-0 d-flex align-center gap-2">
                    <v-btn
                      color="success"
                      :height="isMobile || isTablet ? auto : 50"
                      :width="isMobile || isTablet ? auto : 120"
                      @click="openOptionsDialog('cash-format')"
                    >
                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.32812 13V5.5C2.32812 5.10218 2.48616 4.72064 2.76746 4.43934C3.04877 4.15804 3.4303 4 3.82812 4H15.8281C16.2259 4 16.6075 4.15804 16.8888 4.43934C17.1701 4.72064 17.3281 5.10218 17.3281 5.5V13C17.3281 13.3978 17.1701 13.7794 16.8888 14.0607C16.6075 14.342 16.2259 14.5 15.8281 14.5H3.82812C3.4303 14.5 3.04877 14.342 2.76746 14.0607C2.48616 13.7794 2.32813 13.3978 2.32812 13Z" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14.7031 9.2575L14.7106 9.24925M4.95312 9.2575L4.96063 9.24925M9.82812 11.5C9.23139 11.5 8.65909 11.2629 8.23713 10.841C7.81518 10.419 7.57812 9.84674 7.57812 9.25C7.57812 8.65326 7.81518 8.08097 8.23713 7.65901C8.65909 7.23705 9.23139 7 9.82812 7C10.4249 7 10.9972 7.23705 11.4191 7.65901C11.8411 8.08097 12.0781 8.65326 12.0781 9.25C12.0781 9.84674 11.8411 10.419 11.4191 10.841C10.9972 11.2629 10.4249 11.5 9.82812 11.5Z" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span class="mr-1">{{ $t('recieve-cash') }}</span>
                    </v-btn>
                    <v-btn
                      color="primary"
                      outlined
                      disabled
                      :height="isMobile || isTablet ? auto : 50"
                      :width="isMobile || isTablet ? auto : 120"
                    >
                    <svg width="15" height="15" viewBox="0 0 19 19" fill="silver" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.0095 12.3985L12.6313 2.776M14.474 8.542L12.824 10.192M11.4163 11.5825L10.682 12.3168M3.5 16.75H15.5M2.88125 12.3558C2.60187 12.0765 2.38024 11.7449 2.22903 11.3799C2.07783 11.015 2 10.6238 2 10.2288C2 9.83371 2.07783 9.44254 2.22903 9.07759C2.38024 8.71263 2.60187 8.38104 2.88125 8.10175L8.35175 2.63125C8.63104 2.35187 8.96263 2.13024 9.32759 1.97903C9.69254 1.82783 10.0837 1.75 10.4788 1.75C10.8738 1.75 11.265 1.82783 11.6299 1.97903C11.9949 2.13024 12.3265 2.35187 12.6058 2.63125L16.1188 6.14425C16.3981 6.42354 16.6198 6.75513 16.771 7.12009C16.9222 7.48504 17 7.87621 17 8.27125C17 8.66629 16.9222 9.05746 16.771 9.42242C16.6198 9.78738 16.3981 10.119 16.1188 10.3983L10.6483 15.8688C10.369 16.1481 10.0374 16.3698 9.67242 16.521C9.30746 16.6722 8.91629 16.75 8.52125 16.75C8.12621 16.75 7.73504 16.6722 7.37009 16.521C7.00513 16.3698 6.67354 16.1481 6.39425 15.8688L2.88125 12.3558Z" stroke="silver" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span class="mr-1">{{ $t('send-to-pos') }}</span>
                    </v-btn>
                    <composite 
                      :total="total"
                      :discount="discount"
                      :totalTax="totalTax"
                      @invoiceRemain="invoiceRemain"
                      @totalAmount="totalAmount"
                      :pos="true"
                      :currency="$store.state.currency"
                      :posItems="posItems"
                      :propType="'recieve'"
                      :optionDialogType="optionDialogType"
                      @closeOptionsDialog="optionDialogType = null"
                      @update="onTableUpdate"
                      :editCompositeTableData="editCompositeTableData"
                    />
                  </v-container>
                  <v-container class="pa-0 d-flex align-center gap-2 mt-2">
                    <v-btn
                      v-if="!id"
                      v-shortkey="['f3']"
                      color="primary"
                      :height="isMobile || isTablet ? auto : 50"
                      :width="isMobile || isTablet ? auto : 120"
                      :loading="isLoading"
                      @shortkey="create"
                      @click="create"
                    >
                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.0744 5.25C14.8755 5.25 14.6847 5.32902 14.5441 5.46967C14.4034 5.61032 14.3244 5.80109 14.3244 6V9C14.3244 9.19891 14.2454 9.38968 14.1047 9.53033C13.9641 9.67098 13.7733 9.75 13.5744 9.75H6.38188L7.35689 8.7825C7.49811 8.64127 7.57745 8.44973 7.57745 8.25C7.57745 8.05027 7.49811 7.85873 7.35689 7.7175C7.21566 7.57627 7.02411 7.49693 6.82439 7.49693C6.62466 7.49693 6.43311 7.57627 6.29189 7.7175L4.04189 9.9675C3.9736 10.0388 3.92008 10.1229 3.88439 10.215C3.80937 10.3976 3.80937 10.6024 3.88439 10.785C3.92008 10.8771 3.9736 10.9612 4.04189 11.0325L6.29189 13.2825C6.36161 13.3528 6.44456 13.4086 6.53595 13.4467C6.62735 13.4847 6.72538 13.5043 6.82439 13.5043C6.92339 13.5043 7.02142 13.4847 7.11282 13.4467C7.20421 13.4086 7.28716 13.3528 7.35689 13.2825C7.42718 13.2128 7.48298 13.1298 7.52105 13.0384C7.55913 12.947 7.57873 12.849 7.57873 12.75C7.57873 12.651 7.55913 12.553 7.52105 12.4616C7.48298 12.3702 7.42718 12.2872 7.35689 12.2175L6.38188 11.25H13.5744C14.1711 11.25 14.7434 11.0129 15.1654 10.591C15.5873 10.169 15.8244 9.59674 15.8244 9V6C15.8244 5.80109 15.7454 5.61032 15.6047 5.46967C15.4641 5.32902 15.2733 5.25 15.0744 5.25Z" fill="#FCFCFC"/>
                    </svg>
                    <span class="mr-1">{{ $t('submit') }}</span>
                    </v-btn>
                    <v-btn
                      v-if="(!id && !isMobile) && !sellLinkProp"
                      v-shortkey="['f5']"
                      color="secondary"
                      outlined
                      :loading="isLoading"
                      :height="isMobile || isTablet ? auto : 50"
                      :width="isMobile || isTablet ? auto : 120"
                      @shortkey="create('print')"
                      @click="create('print')"
                    >
                      <span style="color: #000;">{{ $t('submit&Print') }}</span>
                    </v-btn>
                    <v-btn
                      v-if="(!id && !isMobile) && !sellLinkProp"
                      v-shortkey="['f4']"
                      color="secondary"
                      outlined
                      :height="isMobile || isTablet ? auto : 50"
                      :width="isMobile || isTablet ? auto : 120"
                      :loading="isLoading"
                      @shortkey="create('printId')"
                      @click="create('printId')"
                    >
                      <span style="color: #000;">{{ $t('submit&PrintId') }}</span>
                    </v-btn>
                  </v-container>
                </div>
                <div>
                  <v-card-text class="pa-0 text-body-2 mb-1">{{ $t('discount') }}</v-card-text>
                  <v-container
                    class="pa-0 ma-0 discount"
                    style="width: 175px;"
                  >
                    <money
                      v-model="discount"
                      :dense="true"
                      :outlined="true"
                      :solo="false"
                      :clearable="true"
                      value-when-is-empty="0"
                      :options="options"
                      class="mb-3 dense"
                      :append-icon="(!percentDiscountStatus ? 'mdi-percent-outline' : null)"
                      :disabled="(sum > 0 ? (percentDiscountStatus ? true : false) : true)"
                      @append="discountChangeStatus"
                      @input="checkTotalDiscount"
                    />
                    <v-text-field
                      v-if="percentDiscountStatus"
                      v-model="discountPercent"
                      append-icon="mdi-currency-usd"
                      placeholder="%"
                      class="ms-1"
                      height="20"
                      outlined
                      dense
                      type="number"
                      max="100"
                      min="0"
                      @keyup="discountCheck"
                      @blur="discountCheck"
                      @click:append="discountChangeStatus"
                    />
                  </v-container>
                  <v-card-text class="pa-0 text-body-2 mt-5">{{ $t('tax') }}</v-card-text>
                  <v-container
                    class="wrapper-toggle-tax mt-1 d-flex align-center pa-0"
                  >
                    <div
                      v-for="(item, index) in taxOption"
                      :key="index"
                      @click="selectTaxOption(item)"
                      class="child flex-fill text-center"
                      :style="{
                      'background-color': selectedTaxOption == item.value ? '#0066ff' : '',
                      'border-color': selectedTaxOption == item.value ? '#0066ff' : 'silver',
                      'color': selectedTaxOption == item.value ? '#fff' : ''
                      }"
                    >
                      <v-card-text class="pa-0 text-body-2">{{ item.label }}</v-card-text>
                    </div>
                  </v-container>
                </div>
                <div class="flex-fill">
                  <div class="header-total d-flex justify-space-between">
                    <v-card-text class="pa-0 text-body-1" style="color: #0066ff;">{{ $t('sum-total') }}</v-card-text>
                    <v-card-text class="pa-0 text-body-1" style="color: #0066ff;">{{ $numberFormat(total) }} {{ $store.state.currency.symbol }}</v-card-text>
                  </div>
                  <div class="body-total d-flex align-center">
                    <v-container class="pa-2" style="border-left: 1px solid silver;">
                      <div class="d-flex justify-space-between align-center">
                        <v-card-text class="pa-0 text-body-2">{{ $t('invoice-total') }}</v-card-text>
                        <v-card-text class="pa-0 text-body-2">{{ $numberFormat(+total - +totalTax + +discount) }}</v-card-text>
                      </div>
                      <div class="d-flex justify-space-between align-center my-3">
                        <v-card-text class="pa-0 text-body-2">{{ $t('tax-total') }}</v-card-text>
                        <v-card-text class="pa-0 text-body-2">{{ $numberFormat(totalTax) }}</v-card-text>
                      </div>
                      <div class="d-flex justify-space-between align-center">
                        <v-card-text class="pa-0 text-body-2">{{ $t('discount-total') }}</v-card-text>
                        <v-card-text class="pa-0 text-body-2">{{ $numberFormat(discount) }}</v-card-text>
                      </div>
                    </v-container>
                    <v-container class="pa-2">
                      <div class="d-flex justify-space-between align-center">
                        <v-card-text class="pa-0 text-body-2">{{ $t('count-of-ware') }}</v-card-text>
                        <v-card-text class="pa-0 text-body-2">{{ $numberFormat(totalCount) }}</v-card-text>
                      </div>
                      <div class="d-flex justify-space-between align-center my-3">
                        <v-card-text class="pa-0 text-body-2">{{ $t('payments-total') }}</v-card-text>
                        <v-card-text class="pa-0 text-body-2">{{ totalPayment ? totalPayment.toLocaleString('fa-IR') : 0 }}</v-card-text>
                      </div>
                      <div class="d-flex justify-space-between align-center">
                        <v-card-text class="pa-0 text-body-2">{{ $t('remain') }}</v-card-text>
                        <v-card-text class="pa-0 text-body-2">{{ $numberFormat(remainInvoice) }}</v-card-text>
                      </div>
                    </v-container>
                  </div>
                </div>
                <div class="d-flex flex-column gap-2">
                  <v-btn 
                    color="error"
                    outlined
                    @click="clearAllItems"
                  >
                    <svg width="15" height="15" viewBox="0 0 16 17" fill="#ff5252" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.625 3.375H5.5C5.56875 3.375 5.625 3.31875 5.625 3.25V3.375ZM5.625 3.375H10.375V3.25C10.375 3.31875 10.4312 3.375 10.5 3.375H10.375V4.5H11.5V3.25C11.5 2.69844 11.0516 2.25 10.5 2.25H5.5C4.94844 2.25 4.5 2.69844 4.5 3.25V4.5H5.625V3.375ZM13.5 4.5H2.5C2.22344 4.5 2 4.72344 2 5V5.5C2 5.56875 2.05625 5.625 2.125 5.625H3.06875L3.45469 13.7969C3.47969 14.3297 3.92031 14.75 4.45312 14.75H11.5469C12.0813 14.75 12.5203 14.3313 12.5453 13.7969L12.9312 5.625H13.875C13.9438 5.625 14 5.56875 14 5.5V5C14 4.72344 13.7766 4.5 13.5 4.5ZM11.4266 13.625H4.57344L4.19531 5.625H11.8047L11.4266 13.625Z" fill="#ff5252"></path>
                    </svg>
                    <span>{{ $t('delete-all-items') }}</span>
                  </v-btn>
                  <segment-display :value="weight" />
                </div>
              </v-container>
            </v-container>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-row class="mx-0 my-2">
            <v-col
              cols="12"
              class="py-1 px-1"
              md="2"
              sm="2"
              :class="{'mb-3' : isMobile}"
            >
              <template>
                <v-text-field
                  id="dueDateId"
                  v-model="dueDate"
                  :label="$t('dueDate')"
                  clear-icon="flaticon2-close-cross"
                  outlined
                  dense
                  clearable
                  @keyup="dueDate = null"
                />

                <date-picker
                  v-model="dueDate"
                  element="dueDateId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  auto-submit
                  :min="date"
                  :max="$store.state.endDate"
                  :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </template>
            </v-col>
            <v-col
              v-show="(type == 'presale' || type == 'sell'|| type == 'returnSell') && (bodyStatus == false || !isMobile)"
              cols="12"
              class="py-1 px-1"
              sm="2"
              md="2"
            >
              <v-text-field
                v-model="officialNumber"
                height="20"
                dense
                outlined
                class="mb-3 dense"
                clearable
                :label="$t('officialNumber')"
                @blur="getOfficialInvoiceNumber"
              />
            </v-col>
            <v-col
              class="py-1 px-1"
              cols="12"
              md="2"
              sm="2"
              style="height: 20px"
              :class="{'mb-5' : isMobile}"
            >
              <status
                v-model="status"
                :hideconfig="true"
                :type="type"
                :value="status"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
              class="py-1 px-1"
              :class="{'mb-3' : isMobile}"
            >
              <tag
                v-model="tag"
                :solo="false"
                :input="tag"
                :height="25"
              />
            </v-col>
            <v-col
              v-show="showCurrency && !isMobile"
              cols="12"
              sm="2"
              md="2"
              class="py-1 px-1"
              :class="{'mb-3' : isMobile}"
            >
              <autocomplete
                ref="refCurrency"
                v-model="currency"
                :rules="[v => !!v || $t('is-required')]"
                :title="$t('currency')"
                type="currency"
                :init="defaultCurrency"
                :value="currency"
                :offline="offline"
                :set-offline="offline"
                @change="changeCurrency"
              />
            </v-col>
            <v-col
              v-show="showCurrency && !isMobile"
              cols="12"
              sm="2"
              md="2"
              :class="{'mb-0' : isMobile}"
              class="py-1 px-1"
            >
              <money
                v-model="currency_amount"
                :label="$t('currency-rate')"
                :dense="true"
                :outlined="true"
                :solo="false"
                :clearable="true"
                value-when-is-empty=""
                :options="options"
                class="mb-3 dense"
              />
            </v-col>
            <v-col
              cols="12"
              sm="2"
              md="2"
              :class="{'mb-3' : isMobile}"
              class="py-1 px-1"
            >
              <aicomplete
                v-model="branch"
                title="branch"
                type="branch"
                :set-init="true"
                :val="branch"
                :offline="offline"
                :set-offline="offline"
                :new-btn="true"
              />
            </v-col>
            <v-col
              cols="12"
              :class="{'mb-3' : isMobile}"
              md="2"
              sm="2"
              class="mb-0 px-1 py-1"
            >
              <v-select
                v-model="type"
                :label="$t('documentType')"
                :items="typeItems"
                :disabled="(this.$route.name === 'presaleEdit' || itemsProp ? false : true)"
                height="30"
                dense
                outlined
                item-value="value"
                item-text="text"
                item-disabled="disable"
                @input="checkProductsCount"
              />
            </v-col>
            <v-col
              cols="12"
              :class="{'mb-3' : isMobile}"
              md="2"
              sm="2"
              class="mb-0 px-1 py-1"
            >
              <autocomplete
                v-model="given"
                :title="$t('accountGiven')"
                :offline="offline"
                :set-offline="offline"
                type="given"
              />
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
      <v-card-actions class="pt-0 px-3 pb-0" />
    </v-form>
    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            class="pb-2 px-2"
            cols="12"
          >
            <print
              :data-prop="reportData"
              :report-prop="reportName"
              :resource-prop="reportName"
            />
          </v-col>
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogPriceChange"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5">
          Use Google's location service?
        </v-card-title>

        <v-card-text>
          Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="green darken-1"
            text
            @click="dialogPriceChange = false"
          >
            {{ $t('yes') }}
          </v-btn>

          <v-btn
            color="pink darken-1"
            text
            @click="dialogPriceChange = false"
          >
            {{ $t('no') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="loadingDialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <p
            style="color: white"
            class="text-center"
          >
            {{ (!lodingText ? $t('syncData') : $t(lodingText)) }} ...
          </p>
          <v-progress-linear
            v-model="progressPercent"
            color="amber"
            height="5"
          />
          <div align="center">
            <p class="white--text mb-0">
              {{ Math.ceil(progressPercent) }}%
            </p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="helpDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      :width="(isMobile ? '100%' : '50%')"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="helpDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-card
          class="mx-auto"
          flat
        >
          <v-card-text>
            <div class="text--primary">
              {{ $t('indexCategoryHelpContent') }}
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              outlined
              color="deep-purple accent-4"
              class="ms-2"
              @click="downloadTools"
            >
              {{ $t('downloadSoftware') }}
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="configDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      :width="(isMobile ? '100%' : '50%')"
    >
      <v-card class="pa-5" height="400">
        <v-container class="pa-0 d-flex justify-space-between mb-8">
          <v-card-text class="pa-0 text-body-1">{{ $t('setting') }}</v-card-text>
          <v-icon size="20" @click="configDialog = false" style="cursor: pointer;">mdi-close</v-icon>
        </v-container>
        <v-tabs vertical>
          <v-tab class="justify-start">
            <img src="@/assets/cash-register/fast-access.png" />
            <v-card-text class="pa-0 text-body-2 ms-2">{{ $t('fast-access') }}</v-card-text>
          </v-tab>
          <v-tab class="justify-start">
            <img src="@/assets/cash-register/pos.png" />
            <v-card-text class="pa-0 text-body-2 ms-2">{{ $t('pos-device') }}</v-card-text>
          </v-tab>
          <v-tab class="justify-start" disabled>
            <img src="@/assets/cash-register/scales.png" />
            <v-card-text class="pa-0 text-body-2 ms-2">{{ $t('scale') }}</v-card-text>
          </v-tab>
          <v-tab class="justify-start" disabled>
            <img src="@/assets/cash-register/printer.png" />
            <v-card-text class="pa-0 text-body-2 ms-2">{{ $t('printer') }}</v-card-text>
          </v-tab>
          <v-tab class="justify-start" disabled>
            <img src="@/assets/cash-register/other-setting.png" />
            <v-card-text class="pa-0 text-body-2 ms-2">{{ $t('otherSetting') }}</v-card-text>
          </v-tab>
          <v-tab-item>
            <v-card-text class="pa-0 text-body-2 mb-5">{{ $t('dashboard') }}</v-card-text>
            <v-container class="pa-0 d-flex flex-column gap-2">
              <v-container class="box px-3 py-2">
              <v-container class="pa-0 d-flex justify-space-between">
                <div class="d-flex align-center gap-3">
                  <img src="@/assets/cash-register/fund.png" />
                  <div>
                    <v-card-text class="pa-0 text-body-2">{{ $t('default-cach') }}</v-card-text>
                    <v-card-text class="pa-0 text-caption mt-1" style="color: #747373;">برای تنظیم کردن میزان استفاده ترازو مقدار آن را صفر میکند</v-card-text>
                  </div>
                </div>
                <autocomplete
                  v-if="currency"
                  v-model="defaultCash"
                  :title="$t('cash')"
                  :currency-prop="currency.id"
                  type="bankCash"
                  class="mt-1"
                />
              </v-container>
              </v-container>
              <v-container class="box px-3 py-2">
                <v-container class="pa-0 d-flex justify-space-between align-center">
                  <div class="d-flex align-center gap-3">
                    <img src="@/assets/cash-register/calculator.png" />
                    <div>
                      <v-card-text class="pa-0 text-body-2">{{ $t('calculator') }}</v-card-text>
                      <v-card-text class="pa-0 text-caption mt-1" style="color: #747373;">برای تنظیم کردن میزان استفاده ترازو مقدار آن را صفر میکند</v-card-text>
                    </div>
                  </div>
                  <v-btn
                    color="primary"
                    outlined
                    height="32"
                  >
                  {{ $t('unlock') }}
                  </v-btn>
                </v-container>
              </v-container>
              <v-container class="box px-3 py-2">
                <v-container class="pa-0 d-flex justify-space-between align-center">
                  <div class="d-flex align-center gap-3">
                    <img src="@/assets/cash-register/keyboard.png" />
                    <div>
                      <v-card-text class="pa-0 text-body-2">{{ $t('keyboard') }}</v-card-text>
                      <v-card-text class="pa-0 text-caption mt-1" style="color: #747373;">برای تنظیم کردن میزان استفاده ترازو مقدار آن را صفر میکند</v-card-text>
                    </div>
                  </div>
                  <v-btn
                    color="primary"
                    outlined
                    height="32"
                  >
                  {{ $t('unlock') }}
                  </v-btn>
                </v-container>
              </v-container>
            </v-container>
            <v-container class="pa-0 d-flex justify-end mt-5">
              <v-btn
                color="error"
                outlined
                height="32"
              >
              {{ $t('delete-data-base') }}
              </v-btn>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container class="pa-0 d-flex justify-space-between">
              <v-card-text class="pa-0 text-body-1 mb-5">{{ $t('pos-device') }}</v-card-text>
              <v-btn
                color="primary"
                outlined
                height="32"
                @click="openPosDialog('add')"
              >
                {{ $t('add-new-device') }}
              </v-btn>
            </v-container>
            <v-data-table
              :headers="posHeaders"
              :items="posItems"
              :items-per-page="-1"
              hide-default-footer
              :height="(isMobile || isTablet ? 265 : 252)"
              fixed-header
              class="pos-table mt-3"
            >
              <template v-slot:item.status="{ item, index }">
                <v-checkbox
                  v-model="item.status"
                  :true-value="'active'"
                  :false-value="null"
                  @change="setActiveStatus(index)"
                />
              </template>
              <template v-slot:item.title="{ item, index }">
                {{ index + 1 }} {{ item.title }}
              </template>
              <template v-slot:item.posDevice="{ item }">
                {{ item.posDevice.name }}
              </template>
              <template v-slot:item.bank="{ item }">
                {{ item.bank.name }}
              </template>
              <template v-slot:item.terminalNumber="{ item }">
                {{ item.terminalNumber }}
              </template>
              <template v-slot:header.edit="{ header }">
                <v-container class="pa-0 d-flex align-center justify-space-between ma-0 gap-2">
                  {{ $t('edit') }}
                  <div
                    style="cursor: pointer;"
                  >
                    <svg class="mt-1" width="15" height="15" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5.625 3.375H5.5C5.56875 3.375 5.625 3.31875 5.625 3.25V3.375ZM5.625 3.375H10.375V3.25C10.375 3.31875 10.4312 3.375 10.5 3.375H10.375V4.5H11.5V3.25C11.5 2.69844 11.0516 2.25 10.5 2.25H5.5C4.94844 2.25 4.5 2.69844 4.5 3.25V4.5H5.625V3.375ZM13.5 4.5H2.5C2.22344 4.5 2 4.72344 2 5V5.5C2 5.56875 2.05625 5.625 2.125 5.625H3.06875L3.45469 13.7969C3.47969 14.3297 3.92031 14.75 4.45312 14.75H11.5469C12.0813 14.75 12.5203 14.3313 12.5453 13.7969L12.9312 5.625H13.875C13.9438 5.625 14 5.56875 14 5.5V5C14 4.72344 13.7766 4.5 13.5 4.5ZM11.4266 13.625H4.57344L4.19531 5.625H11.8047L11.4266 13.625Z" fill="black"></path>
                    </svg>
                  </div>
                </v-container>
              </template>
              <template v-slot:item.edit="{ item }">
                <v-container class="pa-0 d-flex align-center ma-0 justify-space-between">
                  <div
                    style="cursor: pointer;"
                    class="pr-2"
                    @click="openPosDialog('edit', item)"
                  >
                    <svg width="15" height="15" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.66797 14.5002H13.3346M3.77864 9.29156C3.49438 9.57645 3.33471 9.96244 3.33464 10.3649V12.5002H5.4833C5.88597 12.5002 6.27197 12.3402 6.55664 12.0549L12.89 5.71822C13.1741 5.43329 13.3337 5.0473 13.3337 4.64489C13.3337 4.24248 13.1741 3.85649 12.89 3.57156L12.2646 2.94489C12.1236 2.80379 11.9562 2.69187 11.7718 2.61554C11.5875 2.5392 11.39 2.49994 11.1905 2.5C10.991 2.50006 10.7935 2.53944 10.6092 2.6159C10.425 2.69235 10.2576 2.80437 10.1166 2.94556L3.77864 9.29156Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </div>
                  <div
                    style="cursor: pointer;"
                    @click="removePosRecord(item)"
                  >
                    <svg width="15" height="15" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5.625 3.375H5.5C5.56875 3.375 5.625 3.31875 5.625 3.25V3.375ZM5.625 3.375H10.375V3.25C10.375 3.31875 10.4312 3.375 10.5 3.375H10.375V4.5H11.5V3.25C11.5 2.69844 11.0516 2.25 10.5 2.25H5.5C4.94844 2.25 4.5 2.69844 4.5 3.25V4.5H5.625V3.375ZM13.5 4.5H2.5C2.22344 4.5 2 4.72344 2 5V5.5C2 5.56875 2.05625 5.625 2.125 5.625H3.06875L3.45469 13.7969C3.47969 14.3297 3.92031 14.75 4.45312 14.75H11.5469C12.0813 14.75 12.5203 14.3313 12.5453 13.7969L12.9312 5.625H13.875C13.9438 5.625 14 5.56875 14 5.5V5C14 4.72344 13.7766 4.5 13.5 4.5ZM11.4266 13.625H4.57344L4.19531 5.625H11.8047L11.4266 13.625Z" fill="black"></path>
                    </svg>
                  </div>
                </v-container>
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item></v-tab-item>
          <v-tab-item></v-tab-item>
          <v-tab-item></v-tab-item>
        </v-tabs>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="addNewPosDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      :width="(isMobile ? '100%' : '25%')"
    >
      <v-card class="pa-5">
        <v-form ref="posForm" v-model="valid">
          <v-container class="pa-0 d-flex justify-space-between align-center mb-8">
            <v-card-text class="pa-0 text-body-1">{{ dialogType == 'add' ? $t('new-pos-device') : $t('edit-pos-device') }}</v-card-text>
            <v-icon size="20">mdi-close</v-icon>
          </v-container>
          <v-card-text class="pa-0 text-caption">اطلاعات دستگاه پوز خود را وارد کنید</v-card-text>
          <v-text-field
            v-model="newPos.title"
            :label="$t('caption')"
            :rules="[v => !!v || $t('is-required')]"
            outlined
            dense
            clearable
            class="mt-2"
          />
          <v-autocomplete
            v-model="newPos.posDevice"
            :rules="[v => !!v || $t('is-required')]"
            :label="$t('chose-device')"
            class="mt-8"
            outlined
            :items="posDevices"
            item-text="name"
            return-object
          />
          <v-text-field
            v-model="newPos.terminalNumber"
            :label="$t('terminalNumber')"
            :rules="[v => !!v || $t('is-required')]"
            outlined
            dense
            clearable
          />
          <autocomplete
            v-model="newPos.bank"
            :rules="[v => !!v || $t('is-required')]"
            :title="$t('chose-bank')"
            type="bankCash"
            class="mt-8"
          />
          <v-textarea
            :label="$t('description')"
            v-model="newPos.description"
            outlined
            class="mt-8"
          />
          <v-container class="pa-0 d-flex align-center gap-2">
            <v-btn
              color="primary"
              height="32"
              @click="checkValidation"
            >
            {{ dialogType == 'add' ? $t('confirm') : $t('edit') }}
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              height="32"
            >
            {{ $t('cancel') }}
            </v-btn>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="numpadDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="323"
    >
      <v-card style="background-color: #e3e3e3">
        <v-col class="d-flex pt-2 pb-0">
          <v-btn
            icon
            @click="numpadDialog = false"
          >
            <v-icon
              class="close-hover"
              large
              color="grey"
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-card-text class="pa-0">
          <div
            class="overflow-y-auto ma-1 mx-0 mt-0"
          >
            <numpad
              :input="numpadValue"
              @save="setNumpad"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
    <!--<div
      v-show="bottomNavigation"
      class="text-center buttom-Button-sheet pa-2"
    >
      <v-btn
        v-if="!sellLinkProp && type === 'sell' "
        v-shortkey="['f6']"
        color="teal"
        height="38"
        class="me-2"
        :loading="isLoading"
        @shortkey="sendToPos"
        @click="sendToPos"
      >
        {{ $t('pos&submit') }} (f6)
      </v-btn>
      <v-btn
        v-if="(!id && !isMobile) && !sellLinkProp "
        v-shortkey="['f5']"
        color="primary"
        height="38"
        class="me-2"
        :loading="isLoading"
        @shortkey="create('print')"
        @click="create('print')"
      >
        {{ $t('submit&Print') }} (f5)
      </v-btn>
      <v-btn
        v-if="(!id && !isMobile) && !sellLinkProp "
        v-shortkey="['f4']"
        color="blue"
        height="38"
        class="me-2"
        :loading="isLoading"
        @shortkey="create('printId')"
        @click="create('printId')"
      >
        {{ $t('submit&PrintId') }} (f4)
      </v-btn>
      <v-btn
        v-if="id"
        color="blue"
        height="38"
        class="me-2"
        :loading="isLoading"
        @click="update('print')"
      >
        {{ $t('update&Print') }} (f4)
      </v-btn>
      <v-btn
        v-if="!id"
        v-shortkey="['f3']"
        height="38"
        style="background-color: #4CAF50 !important;"
        :loading="isLoading"
        @shortkey="create"
        @click="create"
      >
        {{ $t('submit') }} (f3)
      </v-btn>
      <v-btn
        v-if="id"
        v-shortkey="['f3']"
        color="primary"
        height="38"
        :loading="isLoading"
        @shortkey="update"
        @click="update"
      >
        {{ $t('edit') }} (f3)
      </v-btn>
      <v-spacer />
      <v-btn
        v-if="id"
        color="teal"
        height="38"
        class="mx-3"
        :loading="isLoading"
        @click="clearForm"
      >
        {{ $t('newInvoice') }}
      </v-btn>
      <v-btn
        color="pink"
        height="38"
        :loading="isLoading"
        @click="clearAllItems"
      >
        {{ $t('removeAllItems') }}
      </v-btn>
    </div>-->
    <Confirm ref="confirm" />
    <div
      ref="refPrint"
      style="display: none"
    >
      <index-print
        :account-prop="account"
        :date-prop="date"
        :items-prop="items"
        :sum-prop="total"
        :total-discount="totalDiscount"
        :total-tax="totalTax"
        :id-prop="idPrint"
        :number-prop="number"
        :status-prop="printStatus"
        :content-prop="content"
      />
    </div>
    <v-dialog
      v-model="addProductDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="95%"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn
            icon
            @click="addProductDialog = false"
          >
            <v-icon
              class="close-hover"
              large
              color="grey"
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-card-text class="pa-0">
          <div
            class="overflow-y-auto ma-2 mx-0 mt-0"
            style=" height: 400px"
          >
            <product
              v-model="newProduct"
              :invoice-trigger="true"
              form-type="product"
              @addproduct="addProductFromDialog"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
  import Task from '../task/task'
  import General from '../../../../Mixins/general'
  import autocomplete from '../../components/general/patial/autocomplete'
  import Description from '../../components/general/description/Description'
  import print from './../../components/general/printViewer/printViewer'
  import segmentDisplay from './../../components/general/7segment/index.vue'
  import indexPrint from './indexCategoryPrint.vue'
  import Product from './../product/product.vue'
  import invoiceItems from './partial/indexCategoryItems.vue'
  import Composite from './partial/Composite.vue'
  function initialData () {
    return {
      lastId: null,
      currentId: 0,
      createIdInvoice: null,
      otherProductCounter: 1,
      pattern: 1,
      selected: [],
      configDialog: false,
      addProductDialog: false,
      helpDialog: false,
      bottomNavigation: true,
      defaultCash: null,
      numpadDialog: null,
      numpadValue: null,
      selectedItemNumpad: null,
      newProduct: null,
      paymentAmount: null,
      cashAmount: null,
      paymentByPos: null,
      customPaymentAmount: false,
      lodingText: null,
      idPrint: null,
      printStatus: 'print',
      fullscreen: false,
      searchBarcode: null,
      numberForEdit: null,
      abrName: null,
      weight: null,
      tab: null,
      scale: false,
      uid: null,
      ouid: null,
      redirectUrl: true,
      websocketWeight: false,
      checkDiscountEdit: false,
      abrironPrinter: false,
      render: true,
      validBank: true,
      selectRow: null,
      given: null,
      offlineSaveStatus: null,
      offline: false,
      nextPermission: false,
      officialNumber: null,
      tableHeightInvoice: 380,
      showCurrency: true,
      reportData: null,
      reportName: null,
      plan: null,
      percentDiscountStatus: false,
      bodyStatus: false,
      dialogPriceChange: false,
      allowPriceChange: false,
      invoicePrintType: 'normal',
      printDialog: false,
      discountEdit: 0,
      checkNumber: false,
      checkOfficialNumber: false,
      deletDialog: false,
      showClearing: true,
      showSelect: false,
      showProductList: false,
      clearingStatus: false,
      filter: false,
      valid: true,
      number: null,
      bank: null,
      entrepot: null,
      payments: null,
      checks: null,
      account: null,
      dueDate: null,
      date: null,
      currency_amount: null,
      content: null,
      model: null,
      printType: 'fish',
      from: 1,
      taskDialog: null,
      id: null,
      status: null,
      tag: null,
      currency: null,
      temp: null,
      taxPercent: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      typeItems: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 1000,
      isLoading: false,
      snakbar: false,
      type: 'sell',
      taskId: null,
      snakbarText: null,
      loading: true,
      tableOptions: {
        itemsPerPage: 1000,
      },
      headers: null,
      search: null,
      discountPercent: false,
      taxStatus: false,
      totalCount: 0,
      discount: 0,
      totalDiscount: 0,
      totalTax: 0,
      totalFee: 0,
      sumRow: 0,
      sum: 0,
      appendTimer: 0,
      decimal: 0,
      weightInterval: null,
      autoPrint: true,
      totalDiscountType: false,
      itemsTableBodyHeight: 300,
      barcodeQueue: [], // صف بارکدها
      processingBarcode: false, // آیا در حال پردازش بارکد هستیم
      barcodeInputThreshold: 300, // زمان بین کلیدهای بارکد
      lastKeypressTime: 0, // زمان آخرین کلید
      barcode: '', // رشته بارکد فعلی
      selectedTaxOption: 'deactive',
      remainInvoice: null,
      totalPayment: null,
      posHeaders: [],
      posItems: [],
      isPosActive: false,
      addNewPosDialog: false,
      newPos: {
        title: null,
        posDevice: null,
        terminalNumber: null,
        bank: null,
        description: null,
        status: null
      },
      dialogType: null,
      selectedIndex: null,
      optionDialogType: null,
      compositeTableData: null,
      editCompositeTableData : null,
      posDevices: [
        {
          id: 1,
          name: 'آسان پرداخت 1'
        },
        {
          id: 2,
          name: 'آسان پرداخت 2'
        },
        {
          id: 3,
          name: 'آسان پرداخت 3'
        },
        {
          id: 4,
          name: 'آسان پرداخت 4'
        }
      ]
    }
  }
  export default {
    name: 'InvoiceIndex',
    components: {
      Products: () => import('../../components/general/Products/ProductsWithCategory.vue'),
      Tag: () => import('../../components/general/Tag/tag'),
      Status: () => import('../../components/general/Status/status'),
      numpad: () => import('../../components/general/numpad/index.vue'),
      invoiceItems,
      Description,
      indexPrint,
      Product,
      print,
      segmentDisplay,
      autocomplete,
      Task,
      Composite
    },
    mixins: [General],
    props: ['input', 'formType', 'refId', 'accountProp', 'itemsProp', 'sellLinkProp', 'returnSellProp'],
    data: function () {
      return initialData()
    },
    computed: {
      total: function () {
        var sum = parseFloat(this.sum) - parseFloat((this.totalDiscount !== '' ? this.totalDiscount : 0))
        this.checkBankRemain(sum)
        return sum.toFixed(this.decimal)
      },
      taxOption () {
        return [
          { label: this.$t('active'), value: 'active' },
          { label: this.$t('deactive'), value: 'deactive' }
        ]
      }
    },
    sockets: {
      getValue: function (data) {
        this.weight = data
      },
    },
    watch: {
      addProductDialog (val) {
        if (val) {
          this.$store.commit('SET_AUTOFOCUS', false)
        } else {
          this.$store.commit('SET_AUTOFOCUS', true)
          this.$store.commit('SET_PREINPUT', null)
          this.$refs.productCategoryRef.setFocus()
        }
      },
      cashAmount (val) {
        if (val && !this.defaultCash) {
          this.configDialog = true
          this.snakbarText = this.$t('pleaseSelectCashForCashPayment')
          this.snakbarColor = 'blue'
          this.snakbar = true
        }
        if (val) {
          var remain = +this.total - +val
          if (remain > 0) {
            this.paymentAmount = remain
          }
        }
      },
      defaultCash (val) {
        localStorage.setItem('defaultCash', JSON.stringify(val))
        this.bank = this.defaultCash
      },
      total (val) {
        this.paymentAmount = val
      },
      customPaymentAmount (val) {
        this.paymentAmount = this.total
      },
      returnSellProp (val) {
        this.onResize()
      },
      abrironPrinter (val) {
        localStorage.setItem('abrironPrinter', val)
      },
      showProductList (val, oldVal) {
        if (val) {
          localStorage.setItem('showProductListInvoice', val)
        } else {
          localStorage.removeItem('showProductListInvoice')
        }
      },
      account (val) {
        if (!this.id) {
          localStorage.setItem('defaultAccount', JSON.stringify(val))
        }
      },
      currency (val, old) {
        this.decimal = 0
        if (val) {
          this.decimal = val.decimal
          if (this.render) {
            this.currency_amount = val.amount
            this.bank = null
          }
        } else {
          this.currency_amount = null
        }
        if (this.render) {
          // this.clearRows()
        }
      },
      taxStatus (val, old) {
        if (val) {
          this.totalDiscountType = false
          this.totalDiscount = 0
          this.discount = 0
        }
        this.calcSum()
      },
      taxPercent (val, old) {
        if (this.taxStatus) {
          this.totalDiscountType = false
          this.totalDiscount = 0
          this.discount = 0
        }
        this.calcSum()
      },
      defaultCurrency () {
        if (this.defaultCurrency && !this.id) {
          this.$refs.refCurrency.setModel(this.defaultCurrency)
          this.currency_amount = this.defaultCurrency.amount
        }
      },
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      payments: {
        handler () {
          var app = this
          app.showClearing = true
          if (app.payments && app.payments.length > 0) {
            app.payments.map(function (value, key) {
              if (value.chip) {
                app.showClearing = false
                app.clearingStatus = false
                app.bank = null
              }
            })
          }
          // app.checks.map(function (value, key) {
          //   if (value.chip) {
          //     app.showClearing = false
          //     app.clearingStatus = false
          //     app.bank = null
          //   }
          // })
        },
        deep: true,
      },
      tableOptions: {
        handler () {
          var app = this
          app.sortBy = []
          app.tableOptions.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
      itemsProp (val) {
        if (val) {
          this.items = val
        } else {
          this.items = []
          this.addRow()
        }
      },
      offline () {
        if (this.offline && !this.callInvoiceByNumber) {
          this.getInvoiceNumberOffline()
        } else {
          this.getInvoiceNumber()
        }
        this.setCookie('offlineInvoice', this.offline)
      },
      scale (val) {
        if (val && val === 'active') {
          this.getWeight()
        } else {
          this.stopWeight()
        }
      },
    },
    activated: function () {
      this.beforeMount()
    },
    beforeMount () {
      this.posHeaders = [
      {
        text: this.$t('status'),
        align: 'start',
        sortable: false,
        value: 'status',
        width: 30
      },
      {
        text: '# ' + this.$t('device-title'),
        align: 'start',
        sortable: false,
        value: 'title'
      },
      {
        text: this.$t('posType'),
        align: 'start',
        sortable: false,
        value: 'posDevice'
      },
      {
        text: this.$t('bank'),
        align: 'start',
        sortable: false,
        value: 'bank'
      },
      {
        text: this.$t('terminalNumber'),
        align: 'start',
        sortable: false,
        value: 'terminalNumber'
      },
      {
        text: this.$t('edit'),
        align: 'start',
        sortable: false,
        value: 'edit'
      },
    ]
      // this.beforeMount()
    },
    mounted () {
      var app = this
      if (this.$route.name === 'invoiceCasher') {
        this.type = 'sell'
      }
      if (this.$route.name === 'returnSellCasher') {
        this.type = 'returnSell'
      }
      if (this.$route.name === 'purchase') {
        this.type = 'purchase'
      }
      if (this.$route.name === 'returnPurchase') {
        this.type = 'returnPurchase'
      }
      if (this.$route.name === 'returnSell') {
        this.type = 'returnSell'
      }
      // this.offline = true
      if (localStorage.getItem('showProductListInvoice')) {
        this.showProductList = true
      }
      if (localStorage.getItem('abrironPrinter')) {
        this.abrironPrinter = localStorage.getItem('abrironPrinter')
      }
      if (localStorage.getItem('defaultCash')) {
        this.defaultCash = JSON.parse(localStorage.getItem('defaultCash'))
        this.bank = this.defaultCash
      }
      if (localStorage.getItem('posDevice')) {
        this.posItems = JSON.parse(localStorage.getItem('posDevice'))
      }
      this.taxPercent = this.$store.state.tax
      this.headers = [
        {
          text: this.$t('actions'),
          align: 'start',
          sortable: false,
          value: 'actions',
          width: 40,
        },
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
          width: 40,
        },
        {
          text: this.$t('product') + '/' + this.$t('service'),
          sortable: false,
          value: 'product',
          width: 300,
        },
        {
          text: this.$t('unit'),
          sortable: false,
          value: 'unit',
          width: 140,
        },
        {
          text: this.$t('count'),
          sortable: false,
          value: 'count',
          width: 200,
        },
        {
          text: this.$t('fee'),
          sortable: false,
          value: 'fee',
          width: 200,
        },
        {
          text: this.$t('discount'),
          sortable: false,
          value: 'discount',
          width: 230,
        },
        {
          text: this.$t('tax'),
          sortable: false,
          value: 'tax',
          width: 160,
        },
        {
          text: this.$t('sum'),
          sortable: false,
          value: 'sum',
          width: 170,
        },
      ]
      var presaleDisable = false
      if (this.$route.name === 'presaleEdit' && this.id) {
        presaleDisable = true
      }
      this.typeItems = [
        {
          value: 'sell',
          text: this.$t('sell'),
        },
        {
          value: 'presale',
          text: this.$t('presale'),
        },
        {
          value: 'returnSell',
          text: this.$t('returnSell'),
          disable: presaleDisable,
        },
        {
          value: 'purchase',
          text: this.$t('purchase'),
          disable: presaleDisable,
        },
        {
          value: 'returnPurchase',
          text: this.$t('returnPurchase'),
          disable: presaleDisable,
        },
      ]
      if (this.input) {
        this.model = this.input
      }
      this.loading = false
      if (this.$route.params.id === null || this.$route.params.id === undefined) {
        // this.addRow()
        // this.currency = this.$store.state.currency
        // this.currency_amount = this.$store.state.currency.amount
      }
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResize)
      })
      if (this.isMobile) {
        this.printType = 'fish'
      }
      // this.getAllProductsOffline(app.type)
      // this.getAllPersonOffline()
      this.getAbrOffline()
      if (app.type === 'returnSell') {
        this.$root.$on('createReturnSell', () => {
          app.redirectUrl = false
          app.create()
        })
      }
      // app.getWeight()
      app.setDefaultCooki()
      var invoiceluncher = localStorage.getItem('invoiceLuncher')
      if (!invoiceluncher) {
        localStorage.setItem('invoiceLuncher', 'dbCreated')
      }
      if (invoiceluncher === 'dbCreated') {
        localStorage.setItem('invoiceLuncher', 'dataSet')
        this.getAllProductsOffline('product')
        this.$store.commit('SET_RELOAD', true)
        this.helpDialog = true
      }
      var defaultAccount = localStorage.getItem('defaultAccount')
      if (defaultAccount) {
        this.account = JSON.parse(defaultAccount)
      }
      window.addEventListener('keydown', this.handleBarcodeScannerInput)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.onResize)
      window.removeEventListener('keydown', this.handleBarcodeScannerInput)
    },
    methods: {
      totalAmount (value) {
        this.totalPayment = value
      },
      invoiceRemain (value) {
        this.remainInvoice = value
      },
      selectTaxOption (item) {
        this.selectedTaxOption = item.value
        if (item.value == 'active') {
          this.taxStatus = 'active'
        } else {
          this.taxStatus = 'deactive'
        }
      },
      openPosDialog (type, selectedItem) {
        this.addNewPosDialog = true

        const socket = new WebSocket('ws://127.0.0.1:8145/Query')
        socket.onopen = function (event) {
          socket.send(JSON.stringify({Key: "POSES"}))
          socket.onmessage(
            
          )
          /* socket.close() */
        }

        if (type == 'add') {
          this.dialogType = 'add'
          if (this.posItems.length > 0) {
            this.clearPosForm()
          }  
        }
        if (type == 'edit' && selectedItem != null) {
          this.dialogType = 'edit'
          this.newPos = {
            title: selectedItem.title,
            posDevice: selectedItem.posDevice,
            terminalNumber: selectedItem.terminalNumber,
            bank: selectedItem.bank,
            description: selectedItem.description,
            status: selectedItem.status
          }
          this.selectedIndex = this.posItems.findIndex(item => item.title == selectedItem.title)
        }
      },
      checkValidation () {
        if (this.$refs.posForm.validate() && this.dialogType == 'add') {
          this.addPosRecord()
        }
        if (this.$refs.posForm.validate() && this.dialogType == 'edit') {
          this.editPosRecord()
        }
      },
      addPosRecord () {
        this.posItems.push(this.newPos)
        this.posItems.forEach((item, index) => {
          item.status = index === 0 ? 'active' : 'deactive'
        })
        this.isPosActive = this.posItems[0].status === 'active'
        this.addNewPosDialog = false
        // console.log('table after add record' + JSON.stringify(this.posItems))
        localStorage.setItem('posDevice', JSON.stringify(this.posItems))
      },
      editPosRecord () {
        this.posItems.splice(this.selectedIndex, 1, this.newPos)
        this.addNewPosDialog = false
        // console.log('table after edit record' + JSON.stringify(this.posItems))
        localStorage.setItem('posDevice', JSON.stringify(this.posItems))
      },
      clearPosForm () {
        this.newPos = {
          title: null,
          posDevice: null,
          terminalNumber: null,
          bank: null,
          description: null,
          status: null
        }
        // reset form
        this.$refs.posForm.reset()
      },
      setActiveStatus(selectedIndex) {
        this.posItems.forEach((item, index) => {
          item.status = index === selectedIndex ? 'active' : 'deactive'
        })
        this.isPosActive = this.posItems[0].status === 'active'
        // console.log(JSON.stringify(this.posItems))
        localStorage.setItem('posDevice', JSON.stringify(this.posItems))
      },
      removePosRecord (selectedItem) {
        const deletedIndex = this.posItems.findIndex(item => item.title == selectedItem.title)
        this.posItems.splice(deletedIndex, 1)
        // console.log('table after delete record' + JSON.stringify(this.posItems))
        localStorage.setItem('posDevice', JSON.stringify(this.posItems))
      },
      openOptionsDialog (value) {
        this.optionDialogType = value
      },
      onTableUpdate (value) {
        this.compositeTableData = value
      },
      handleBarcodeScannerInput (event) {
        const currentTime = new Date().getTime()
        const timeSinceLastKeypress = currentTime - this.lastKeypressTime
        this.lastKeypressTime = currentTime
        if (timeSinceLastKeypress < this.barcodeInputThreshold) {
          if (event.key === 'Enter') {
            this.barcodeQueue.push(this.barcode)
            this.barcode = ''
            if (!this.processingBarcode) {
              this.processBarcodes()
            }
          } else {
            this.barcode += event.key
          }
        } else {
          this.barcode = event.key
        }
      },
      processBarcodes () {
        if (this.barcodeQueue.length > 0) {
          this.processingBarcode = true
          const barcodeToProcess = this.barcodeQueue.shift()
          this.$refs.productCategoryRef.setSearchFocus()
          this.$refs.productCategoryRef.searchBarcode = barcodeToProcess
          this.$refs.productCategoryRef.searchIntegrator()
          setTimeout(() => {
            this.processBarcodes()
          }, 300)
        } else {
          this.processingBarcode = false
        }
      },
      prevInvoice () {
        this.show(this.currentId, 'prev')
      },
      nextInvoice () {
        this.show(this.currentId, 'next')
      },
      otherProduct () {
        var app = this
        var name = (app.$t('otherProduct') + ' ' + app.otherProductCounter).toString()
        var isDB = localStorage.getItem('dbCreated')
        if (isDB && isDB === 'active') {
          var connection = new window.JsStore.Connection()
          connection.openDb('db_' + this.$store.state.userId)
          connection.select({
            from: 'products',
            where: {
              name: name,
            },
          }).then(function (data) {
            if (data && data.length > 0) {
              data[0].price = 0
              app.append(data[0], 'openEdit')
              app.otherProductCounter++
            } else {
              app.$axios.get(app.$endpoint + 'getdetail', {
                params: {
                  select: 'getOtherProduct',
                  name: name,
                },
              })
                .then(res => {
                  res = res.data
                  res.price = 0
                  app.append(res, 'openEdit')
                  connection.insert({ into: 'products', upsert: true, values: [res] })
                  app.otherProductCounter++
                })
                .catch(err => {
                  app.serverErrorHandeler(err)
                })
                .finally(() => function () {
                  app.isLoading = false
                  app.loading = false
                })
            }
          })
        }
      },
      setRefBody (val) {
        this.itemsTableBodyHeight = val
      },
      openNumpad (item) {
        this.selectedItemNumpad = item
        this.numpadValue = item.count
        this.numpadDialog = true
      },
      setNumpad (data) {
        this.numpadDialog = false
        this.selectedItemNumpad.count = data
      },
      addProductFromDialog (data) {
        this.append(data)
        this.addProductDialog = false
        var isDB = localStorage.getItem('dbCreated')
        if (isDB) {
          this.DBCreate()
        }
        if (isDB && isDB === 'active') {
          var connection = new window.JsStore.Connection()
          connection.openDb('db_' + this.$store.state.userId)
          connection.insert({ into: 'products', upsert: true, values: [data] })
        }
        // this.getAllProductsOffline('product')
      },
      downloadTools () {
        window.open('https://abriron.com/abrironapp/abriron-tools-windows.rar', '_blank')
        this.helpDialog = false
      },
      clearAllItems () {
        this.items = []
        this.calcSum()
        this.total = 0
        this.totalTax = 0
        this.discount = 0
        this.totalCount = 0
        this.totalPayment = 0
      },
      searchIntegrator () {
        var isDB = localStorage.getItem('dbCreated')
        if (isDB && isDB === 'active') {
          var app = this
          var connection = new window.JsStore.Connection()
          connection.openDb('db_' + this.$store.state.userId)
          connection.select({
            from: 'products',
            join: {
              with: 'productIntegrator',
              on: 'products.id=productIntegrator.product_id',
              type: 'inner',
              where: {
                value: {
                  like: '%' + (app.searchBarcode ? app.searchBarcode : '') + '%',
                },
              },
            },
            groupBy: 'product_id',
          }).then(function (data) {
          })
        }
      },
      printWithTools () {
        var local = localStorage.getItem('token')
        this.abrName = this.$store.state.abrName
        var data = {
          userId: JSON.parse(local).init.userId + '000',
          body: this.$data,
        }
        this.$socket.emit('setValue', JSON.stringify(data))
      },
      setFocus () {
        if (this.$refs.productCategoryRef) {
          this.$refs.productCategoryRef.setSearchFocus()
        }
        // this.$refs.searchRef.focus()
      },
      fullScreenFunc () {
        this.fullscreen = !this.fullscreen
        if (this.fullscreen) {
          document.getElementById('app').requestFullscreen()
        } else {
          // document.getElementById('app').exitFullscreen()
        }
      },
      async getWeightClipboard () {
        var app = this
        app.weightInterval = setInterval(async function () {
          if (document.hasFocus()) {
            var clip = await navigator.clipboard.readText()
            if (app.isJsonString(clip)) {
              clip = JSON.parse(clip)
              app.weight = clip.weight
            }
          }
        }, 100)
      },
      isJsonString (str) {
        try {
          JSON.parse(str)
        } catch (e) {
          return false
        }
        return true
      },
      getItemWeight (item) {
        var bc = new BroadcastChannel('test_channel')
        bc.postMessage('This is a test message.')
        item.count = parseFloat(this.weight)
      },
      async getWeight () {
        var app = this
        const socket = new WebSocket('ws://localhost:4022/Scale')
        socket.onopen = function (event) {
          socket.send('connect')
          socket.send('getweight')
        }
        socket.onmessage = function (event) {
          if (event.data !== 'Error in getting weight' && event.data !== 'Thread Started' && event.data !== 'Not Connected' && event.data !== 'True') {
            var weight = event.data.split('/')
            if (weight.length > 1) {
              app.weight = weight[0] + '.' + weight[1]
            } else {
              app.weight = weight[0]
            }
          }
        }
      },
      stopWeight () {
        const socket = new WebSocket('ws://localhost:4022/Scale')
        socket.onopen = function (event) {
          // socket.send('connect')
          socket.send('stopweight')
        }
        socket.onmessage = function (event) {
        }
      },
      addCount (item) {
        item.count++
        var app = this
        clearTimeout(this.appendTimer)
        this.appendTimer = setTimeout(function () {
          app.calcSum()
        }, 100)
      },
      minusCount (item) {
        item.count--
        var app = this
        clearTimeout(this.appendTimer)
        this.appendTimer = setTimeout(function () {
          app.calcSum()
        }, 100)
      },
      goToReturnSell () {
        // this.$root.$emit('createReturnSell')
        this.$router.push({ name: 'returnSellCasher', params: { accountProp: this.account, sellLinkProp: true } })
      },
      goToSell () {
        if (!this.$refs.form.validate()) return false
        var data = {
          total: this.total,
        }
        this.$router.push({ name: 'invoiceCasher', params: { returnSellProp: data } })
      },
      setOffline (val) {
        this.offline = val
      },
      unitCalc (item) {
        if (item.product && item.unit) {
          var i = item.product.units.findIndex(x => x.unit_id === item.unit.id)
          if (i !== -1 && item.product.units[i].value) {
            return +item.product.units[i].value
          } else {
            return 1
          }
        }
      },
      unitItems (item) {
        if (item.product) {
          var units = [item.product.unit]
          if (item.product.units) {
            item.product.units.map(function (value, index) {
              value.unit.value = value.value
              units.push(value.unit)
            })
          }
          if (!item.unit) {
            item.unit = item.product.unit
          }
          return units
        } else {
          return []
        }
      },
      onResize () {
        var height = 350
        if (!this.isMobile && window.innerHeight < 750) {
          height = 507
        }
        if (this.isMobile) {
          height = 440 + (this.returnSellProp ? 70 : 0)
        }
        if (this.isMobile && window.innerHeight < 900 && window.innerHeight > 750) {
          height = 460 + (this.returnSellProp ? 70 : 0)
        }
        if (this.isMobile && window.innerHeight < 750) {
          height = 480 + (this.returnSellProp ? 70 : 0)
        }
        this.tableHeightInvoice = window.outerHeight - height
        this.$store.commit('SET_TABLEHEIGHTINVOICE', this.tableHeightInvoice)
      },
      beforeMount () {
        this.bottomNavigation = true
        if (this.accountProp) {
          this.account = this.accountProp
        }
        if (this.$route.params.id != null) {
          this.id = this.$route.params.id
          this.uid = this.$route.params.id
          this.show()
          this.render = false
        } else {
          this.defaultCurrency = this.getDefault('defaultCurrency')
          this.currency = this.$store.state.currency
          if (this.offline && !this.callInvoiceByNumber) {
            this.getInvoiceNumberOffline()
          } else {
            this.getInvoiceNumber()
          }
          if (this.items && this.items.length === 0) {
            // this.addRow()
          }
        }
        if (this.$store.state.currency && !this.id && !this.account) {
          this.currency = this.$store.state.currency
          this.currency_amount = this.$store.state.currency.amount
        }
        if (this.itemsProp) {
          this.items = this.itemsProp
        } else {
          if (!this.isMobile && !this.account && !this.id) {
            this.items = []
            // this.addRow()
          }
        }
        var isDB = localStorage.getItem('dbCreated')
        if (!isDB) {
          this.DBCreate()
        }
      },
      checkProductsCount () {
        var app = this
        if (this.items && this.items.length > 0) {
          this.items.map(function (value, index) {
            // value.product = null
            if (app.$refs['refProduct' + index] !== undefined) {
              // app.$refs['refProduct' + index].clear()
            }
          })
        }
      },
      zeroCountCheck (item) {
        if (parseFloat(item.count) === 0) {
          item.count = 1
          this.checkCount(item)
        }
      },
      discountChangeStatus () {
        this.percentDiscountStatus = !this.percentDiscountStatus
        this.taxStatus = false
      },
      discountCheck () {
        this.discount = 0
        this.totalDiscount = 0
        if (Number(this.discountPercent) > 100) {
          this.discountPercent = 100
        }
        if (Number(this.discountPercent) < 0) {
          this.discountPercent = 0
        }
        if (this.total > 0) {
          var discount = this.total * (this.discountPercent / 100)
          this.discount = discount.toFixed(this.decimal)
          this.checkTotalDiscount()
        }
      },
      checkBankRemain (sum) {
        var app = this
        app.validBank = true
        if (app.type === 'purchase' || app.type === 'returnSell') {
          if (this.clearingStatus && this.bank && sum > parseFloat(this.bank.remain.currency_remain)) {
            app.validBank = true
            app.snakbarText = this.$t('alert-pay-amount-bigger-than-bank-remain')
            app.snakbarColor = 'pink'
            app.snakbar = true
          }
        }
      },
      getInvoiceNumber () {
        if (this.type === 'returnPurchase' || this.type === 'purchase') {
          return false
        }
        this.loading = true
        var app = this
        app.isLoading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              type: app.type,
              id: app.id,
              number: app.number,
              callInvoice: app.callInvoiceByNumber,
              select: 'getInvoiceNumber',
            },
          })
            .then(res => {
              res = res.data
              if (res.status === 'error') {
                if (app.checkNumber && !app.callInvoiceByNumber) {
                  app.snakbarText = res.message
                  app.snakbarColor = 'pink'
                  app.snakbar = true
                }
                app.number = res.number
                if (app.callInvoiceByNumber && res.invoice) {
                  app.id = res.invoice.uid
                  app.show()
                  // app.$router.push({ name: 'invoiceCasherEdit', params: { id: res.invoice.uid, tabName: res.invoice.number } })
                } else {
                  app.number = res.number
                }
              }
              app.number = res.number
              app.checkNumber = true
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(function () {
              app.loading = false
              app.isLoading = false
            })
        }, 50)
      },
      callInvoiceById (e) {
        if (!this.numberForEdit) {
          return false
        }
        this.loading = true
        var app = this
        app.isLoading = true
        this.clearForm()
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              number: app.numberForEdit,
              select: 'getInvoiceUidById',
            },
          })
            .then(res => {
              res = res.data
              if (res.uid) {
                app.id = res.uid
                app.show()
              }
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(function () {
              app.loading = false
              app.isLoading = false
            })
        }, 50)
      },
      getOfficialInvoiceNumber () {
        if (this.type === 'returnPurchase' || this.type === 'purchase') {
          return false
        }
        this.loading = true
        var app = this
        app.isLoading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              type: app.type,
              id: app.id,
              number: app.officialNumber,
              select: 'getOfficialInvoiceNumber',
            },
          })
            .then(res => {
              res = res.data
              if (res.status === 'error') {
                if (app.checkOfficialNumber) {
                  app.snakbarText = res.message
                  app.snakbarColor = 'pink'
                  app.snakbar = true
                }
                app.officialNumber = res.number
              }
              app.checkOfficialNumber = true
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(() => (app.isLoading = false))
        }, 50)
        // setTimeout(() => {
        //   app.$refs.autocomplete.onScroll()
        // }, 1500)
        this.loading = false
      },
      changeProduct (item) {
        if (this.type === 'sell' || this.type === 'returnPurchase' || this.type === 'presale') {
          if (this.currency && item.product && item.product.price && this.currency.id === this.$store.state.currency.id) {
            item.fee = item.product.price
          } else {
            if (!this.id && !this.itemsProp) {
              // item.fee = 0
            }
          }
        }
      },
      clearRow (item) {
        item.fee = 0
        item.count = 0
        item.discount = 0
        item.discountPercent = 0
        item.tax = 0
      },
      clearRows () {
        this.items.map(function (value, index) {
          value.fee = 0
          value.count = 0
          value.discount = 0
          value.discountPercent = 0
          value.tax = 0
        })
      },
      changePercent (val) {
        this.discountPercent = val
        this.percentDiscountStatus = true
      },
      append (product, call = null) {
        this.offline = false
        var app = this
        var count = (product.count ? product.count : 1)
        var stock = 20000000
        if (!this.offline && product.type === 'product') {
          stock = (product.stock ? product.stock.count : 2000000)
          if (this.type === 'sell' || this.type === 'returnPurchase') {
            if (this.offline && (!product.stock || product.stock.count <= 0)) {
              this.snakbarText = this.$t('alert-is-not-enough-inventory')
              this.snakbarColor = 'pink'
              this.snakbar = true
              return false
            }
            if (product.stock && product.stock.count < 1) {
              // count = parseFloat(product.stock.count)
            }
          }
        }
        var index = -1
        // if (this.items && this.items.length == 0) {
        //   this.addRow()
        // }
        if (this.items && this.items.length > 0 && !this.items[0].product) {
          this.items.splice(0, 1)
        }
        index = this.items.findIndex(x => (x.product ? x.product.id === product.id : null))
        if (index !== -1) {
          if (parseFloat(stock) - parseFloat(this.items[index].count) - parseFloat(count) >= 0) {
          }
          this.items[index].count = parseFloat(this.items[index].count) + parseFloat(count)
          if (this.type === 'sell' || this.type === 'presale') {
            if (product && !product.price) {
              this.getPrice(this.items[index])
            }
          }
        } else {
          if (this.scale && this.scale === 'active' && product.unit && product.unit.type === 'jointed') {
            if (product.unit.name === 'Kg') {
              count = parseFloat(this.weight)
            } else {
              count = parseFloat(this.weight * 1000)
            }
          }
          var price = (product.price ? product.price : 0)
          this.addRow(product, count, price)
        }
        clearTimeout(this.appendTimer)
        if (call === 'openEdit') {
          setTimeout(function () {
            app.$refs.refInvoiceItems.openProductEdit(app.items[app.items.length - 1])
          }, 100)
        }
        // this.$refs.refInvoiceItems.scrollToBottom(this)
        this.scrollToBottom(this)
        this.appendTimer = setTimeout(function () {
          app.calcSum()
        }, 250)
      },
      scrollToBottom (app) {
        setTimeout(function () {
          app.$refs.refScroll.scrollTop = app.itemsTableBodyHeight
        }, 50)
      },
      getPrice (item) {
        var app = this
        clearTimeout(this.timer)
        if (!this.showProductList) {
          app.isLoading = true
        }
        this.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              select: 'getPrice',
              currency_id: app.currency.id,
              count: item.count,
              product_id: item.product.id,
              category_id: (app.account && app.account.category_id ? app.account.category_id : -1),
            },
          })
            .then(res => {
              res = res.data
              if (res.price > 0) {
                item.fee = res.price
              } else {
                item.fee = 0
              }
              if (item.fee > 0 && item.count > 0) {
                if (res.discount.amount) {
                  item.discount = res.discount.amount
                }
                if (res.discount.percent && parseFloat(res.discount.percent) > 0) {
                  var discount = (parseFloat(item.fee) * parseFloat(item.count)) * (parseFloat(res.discount.percent) / 100)
                  item.discount = discount
                }
              }
              app.calcSum()
            })
            .catch(err => {
              app.serverErrorHandeler(err)
            })
            .finally(() => (app.isLoading = false))
        }, 500)
        this.loading = false
      },
      calcSum () {
        var app = this
        app.totalTax = 0
        app.totalDiscount = (this.discountEdit ? this.discountEdit : 0)
        app.totalCount = 0
        app.totalFee = 0
        app.sum = 0
        var sumDiscount = 0
        // if (!this.discountPercent) {
        //   this.discount = 0
        // }
        this.items.map(function (value, index) {
          if (value.discountPercent > 0) {
            value.discount = parseFloat(value.fee * value.count) * (value.discountPercent / 100)
          }
          if (parseFloat(value.count) * parseFloat(value.fee) < parseFloat(value.discount)) {
            value.discount = 0
            app.discount = 0
            app.totalDiscount = 0
          }
          if (app.totalDiscountType) {
            value.discount = 0
            value.tax = 0
          } else {
            sumDiscount = sumDiscount + parseFloat(value.discount)
            app.calcTax(value)
          }
          app.totalFee = parseFloat(value.count) * parseFloat(value.fee) + parseFloat(app.totalFee)
          app.totalCount = parseFloat(value.count) + parseFloat(app.totalCount)
          app.totalTax = parseFloat(value.tax) + parseFloat(app.totalTax)
          var rowPrice = parseFloat(value.fee * value.count) - parseFloat((value.discount === '' || !value.discount ? 0 : value.discount)) + parseFloat((isNaN(value.tax) ? 0 : value.tax))
          app.sum = parseFloat(rowPrice) + parseFloat(app.sum)
        })
        app.totalFee = app.totalFee.toFixed(this.decimal)
        app.totalTax = app.totalTax.toFixed(this.decimal)
        if (sumDiscount > 0) {
          app.discount = sumDiscount
          // app.totalDiscount = sumDiscount
        }
        this.discountEdit = 0
      },
      checkTotalDiscount () {
        this.taxStatus = false
        this.totalDiscountType = true
        this.calcSum()
        // if (this.discountPercent) {
        //   if (parseFloat(this.discount) > 100) {
        //     this.discount = 0
        //   }
        //   var discount = parseFloat(this.sum) * (parseFloat(this.discount) / 100)
        //   this.totalDiscount = discount
        // } else {
        this.totalDiscount = this.discount
        // }
        if (this.discountPercent === false && parseFloat(this.discount) > parseFloat(this.sum)) {
          this.discount = 0
          this.totalDiscount = 0
        }
      },
      calcTax (item) {
        if (this.taxStatus === 'active') {
          var tax = (parseFloat(item.fee * item.count) - parseFloat((item.discount === '' || !item.discount ? 0 : item.discount))) * item.taxPercent / 100
          item.tax = tax.toFixed(this.$store.state.currency.decimal)
        } else {
          item.tax = 0
        }
      },
      changeCurrency () {
        this.bankRemain = 0
        this.currency_amount = this.currency.amount
        this.options = {
          locale: 'en-US',
          prefix: '',
          suffix: this.currency.name,
          precision: 0,
        }
      },
      addRow (product = null, count = 0, price = 0) {
        this.items.push({
          product: product,
          count: count,
          countEdit: 0,
          fee: price,
          discount: 0,
          discountPercent: (product && product.discount_percent > 0 ? product.discount_percent : 0),
          tax: 0,
          taxPercent: (product && product.tax_percent > 0 ? product.tax_percent : 0),
          unit: null,
          content: 0,
        })
        if (this.type === 'sell' && product && !product.price) {
          var index = this.items.findIndex(x => x.product.id === product.id)
          this.getPrice(this.items[index])
        }
      },
      remove (item) {
        var i = this.items.indexOf(item)
        this.items.splice(i, 1)
        this.deleteItem = null
        this.calcSum()
        this.deletDialog = false
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'ProductEdit', params: { id: item.id } })
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'products', {
          params: {
            search: app.search,
            page: app.tableOptions.page,
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.tableOptions,
            tag: app.tag,
            // typeForm: app.typeForm,
          },
        })
          .then(res => {
            res = res.data
            app.items = res.data
            app.totalItems = res.total
            app.from = res.from
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      checkProduct (item, key) {
        if (item) {
          var index = this.items.findIndex(x => x.product.id === item.id)
          if (index !== key) {
            this.$refs['refProduct' + key].clear()
            this.snakbarText = this.$t('alert-product-is-repetitive')
            this.snakbarColor = 'pink'
            this.snakbar = true
          }
        }
      },
      checkDiscount (item) {
        this.totalDiscountType = false
        this.totalDiscount = 0
        this.discount = 0
        if (parseFloat(item.discount) > parseFloat(item.fee * item.count)) {
          item.discount = 0
        }
        item.discountPercent = this.itemDiscountPercentCalc(item)
        this.calcSum()
      },
      checkDiscountPercent (item) {
        this.totalDiscountType = false
        this.totalDiscount = 0
        this.discount = 0
        item.discount = (parseFloat(item.fee * item.count) * (item.discountPercent / 100)).toFixed(this.decimal)
        if (parseFloat(item.discount) > parseFloat(item.fee * item.count)) {
          item.discount = 0
          item.discountPercent = 0
        }
        this.calcSum()
      },
      itemDiscountPercentCalc (item) {
        return (parseFloat(item.discount) / parseFloat(item.fee * item.count)) * 100
      },
      checkCount (item) {
        if (!this.offline && (this.type === 'sell' || this.type === 'presale' || this.type === 'returnPurchase')) {
          var productStock = (item.product && item.product.stock ? parseFloat(item.product.stock.count) : 0)
          if (item.product && item.product.type === 'product' && this.$store.state.negative_inventory === 'no' && parseFloat(item.count) > productStock + parseFloat((this.$route.name !== 'presaleEdit' ? item.countEdit : 0))) {
            this.snakbarText = this.$t('alert-inventory-is-not-enough')
            this.snakbarColor = 'pink'
            this.snakbar = true
            // item.count = 0
          } else {
            if (this.$route.name !== 'presaleEdit' && item.product && !item.product.price) {
              if (this.type === 'sell' || this.type === 'presale') {
                this.getPrice(item)
              }
            }
          }
        }
        this.calcSum()
      },
      removegroup () {
        var app = this
        app.selected.map(function (value, key) {
          app.remove(value, key)
        })
      },
      createOffline () {
        if (!this.$refs.form.validate()) return false
        var app = this
        var token = JSON.parse(localStorage.getItem('token'))
        var list = JSON.parse(localStorage.getItem('invoice'))
        if (!list) {
          list = []
        }
        this.ouid = token.init.userId + '@' + Date.now() + '@' + this.number
        list.push(this.$data)
        localStorage.setItem('invoice', JSON.stringify(list))
        localStorage.setItem('invoiceNumber', this.number)
        if (!this.$store.state.offlineInvoiceTrigger) {
          this.createInvoiceOffline()
        }
        this.$store.commit('SET_OFFLINEINVOICETRIGGER', true)
        if (app.autoPrint && app.redirectUrl) {
          if (app.type === 'sell' || app.type === 'presale') {
            if (app.printType === 'normal') {
              app.$router.push({ name: 'invoicePrint', params: { id: this.ouid, offlineProp: true } })
            } else {
              var numberPrintForNewInvoice = (this.type === 'sell' && !this.id && this.$store.state && this.$store.state.allConfig && this.$store.state.allConfig.printNumberForNewInvoice === 'active' ? true : null)
              app.$router.push({ name: 'invoiceRollprint', params: { id: this.ouid, backUrl: 'invoiceCasher', offlineProp: true, abrironPrinterProp: app.abrironPrinter, numberPrint: numberPrintForNewInvoice } })
            }
          } else {
            app.goTo(app.type + 'List')
          }
        }
        app.items = []
        app.account = null
        if (app.type === 'sell' && app.returnSellProp) {
          // app.$root.$emit('createReturnSell')
        }
        app.redirectUrl = true
      },
      createInvoiceHeader (type = null) {
        var app = this
        var checkVisitor = false
        if (!this.account) {
          this.pattern = 2
        }
        if (!this.$refs.form.validate()) return false
        if (this.type === 'sell' && this.$store.state.allConfig && this.$store.state.allConfig.userInt && this.$store.state.allConfig.userInt.visitor === 'active') {
          checkVisitor = true
        }
        if (this.items.length === 0) {
          app.snakbarText = app.$t('noItems')
          app.snakbarColor = 'pink'
          app.snakbar = true
          return false
        }
        if (!this.account) {
          app.snakbarText = app.$t('noAccount')
          app.snakbarColor = 'pink'
          app.snakbar = true
          return false
        }
        if (this.offline && !checkVisitor) {
          // this.createOffline()
          // this.clearForm()
          // return false
        }
        app.createIdInvoice = 'active'
        app.snakbar = false
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'invoice', this.$data)
          .then(res => {
            res = res.data
            app.idPrint = res.id
            app.id = res.id
            app.uid = res.uid
            app.redirectUrl = true
            app.printStatus = type
            setTimeout(function () {
              if (type === 'printId' || type === 'print') {
                app.print()
              }
              // app.clearForm()
            }, 100)
            app.update()
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.nextPermission = false
            this.redirectUrl = true
            this.isLoading = false
          })
      },
      create (type = null) {
        var app = this
        var checkVisitor = false
        if (!this.account) {
          this.pattern = 2
        }
        if (!this.$refs.form.validate()) return false
        // this.items.map(function (value, index) {
        //   if (!value.product) {
        //     this.remove(value, index)
        //   }
        // })
        if (this.type === 'sell' && this.$store.state.allConfig && this.$store.state.allConfig.userInt && this.$store.state.allConfig.userInt.visitor === 'active') {
          checkVisitor = true
        }
        if (this.items.length === 0) {
          app.snakbarText = app.$t('noItems')
          app.snakbarColor = 'pink'
          app.snakbar = true
          return false
        }
        if (!this.account) {
          app.snakbarText = app.$t('noAccount')
          app.snakbarColor = 'pink'
          app.snakbar = true
          return false
        }
        if (this.offline && !checkVisitor) {
          // this.createOffline()
          // this.clearForm()
          // return false
        }
        app.snakbar = false
        app.isLoading = true
        if (type === 'printId' || type === 'print') {
          app.print()
        }
        /* app.print() */
        app.$axios.post(this.$endpoint + 'invoice', this.$data)
          .then(res => {
            res = res.data
            app.nextPermission = true
            if (res.status === 'success') {
              app.snakbarText = app.$t('registered')
              app.snakbarColor = 'green'
              app.snakbar = true
              if (checkVisitor) {
                app.account = null
              }
              app.idPrint = res.data.id
              app.redirectUrl = true
              app.printStatus = type
              app.lastId = res.data.id
              app.currentId = res.data.id
              // setTimeout(function () {
              app.clearForm()
              // }, 100)
            } else {
              app.snakbarText = app.$t('error')
              app.snakbarColor = 'green'
              app.snakbar = true
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.nextPermission = false
            this.redirectUrl = true
            this.isLoading = false
          })
      },
      update (type = null) {
        var app = this
        app.snakbar = false
        app.isLoading = true
        if (type === 'printId' || type === 'print') {
          app.print()
        }
        app.$axios.put(this.$endpoint + 'invoice/' + this.uid, this.$data)
          .then(res => {
            res = res.data
            // app.nextPermission = true
            app.clearableForm()
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.nextPermission = false
            this.isLoading = false
          })
      },
      show (currentId = null, order = null) {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'invoice/' + this.id + '/edit', {
          params: {
            id: this.id,
            currentId: currentId,
            order: order,
          },
        })
          .then(res => {
            app.$nextTick(() => {
              if (res.data !== '') {
                res = res.data
                app.id = res.id
                if (!app.lastId) {
                  app.lastId = res.id
                }
                app.currentId = res.id
                app.uid = res.uid
                app.currency = res.currency
                app.decimal = (res.currency ? res.currency.decimal : 0)
                app.currency_amount = res.currency_amount
                app.number = res.number
                app.officialNumber = res.official_number
                app.content = res.content
                app.date = res.date
                app.given = res.given
                app.type = res.type
                app.items = res.article
                app.account = res.customer
                app.entrepot = (res.entrepot ? res.entrepot.entrepot : null)
                app.dueDate = res.due_date
                app.branch = res.branch
                app.payments = res.payments
                app.checks = res.checks
                app.status = (res.last_status ? res.last_status.status : null)
                app.discount = res.discount
                app.plan = (res.plan ? res.plan.plan : null)
                app.totalDiscount = res.discount
                app.compositeTableData = res.compositeTableData
                app.editCompositeTableData = [...res.compositeTableData]
                app.items.map(function (value, index) {
                  if (value.discount && value.discount > 0) {
                    app.checkDiscountEdit = true
                  }
                })
                if (!app.checkDiscountEdit) {
                  app.discountEdit = res.discount
                }
                // app.totaltax = res.tax
                if (res.tax > 0) {
                  app.taxStatus = 'active'
                  app.taxPercent = res.tax_percent
                }
                if (res.tags) {
                  app.tag = res.tags
                  app.more = true
                }
                setTimeout(function () {
                  app.render = true
                }, 1000)
                app.calcSum()
              }
            })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      getInvoiceNumberOffline () {
        if (this.type === 'returnPurchase' || this.type === 'purchase') {
          return false
        }
        var number = JSON.parse(localStorage.getItem('invoiceNumber'))
        if (!number) {
          number = 1
        } else {
          number = +number + 1
        }
        this.number = number
      },
      clearableForm () {
        this.id = null
        this.account = null
        this.numberForEdit = null
        this.clearForm()
      },
      clearForm () {
        this.selected = []
        this.render = true
        this.otherProductCounter = 1
        this.createIdInvoice = null
        this.paymentByPos = null
        this.cashAmount = null
        this.paymentAmount = null
        this.lodingText = null
        this.loadingDialog = false
        this.bodyStatus = false
        this.printDialog = false
        this.deletDialog = false
        this.showClearing = true
        this.showSelect = false
        this.showProductList = false
        // this.clearingStatus = false
        this.filter = false
        this.valid = true
        this.number = null
        // this.bank = null
        this.given = null
        // this.entrepot = null
        this.payments = null
        this.uid = null
        this.checks = null
        this.officialNumber = null
        // this.account = null
        this.dueDate = null
        // this.date = null
        // this.currency_amount = null
        this.content = null
        this.model = null
        this.from = 1
        this.taskDialog = null
        this.id = null
        this.status = null
        this.tag = null
        this.temp = null
        this.deleteItem = null
        this.sellStatus = null
        this.items = []
        this.dialog = null
        this.timer = 0
        this.isLoading = false
        this.snakbar = false
        this.taskId = null
        this.snakbarText = null
        this.loading = false
        this.search = null
        this.discountPercent = false
        this.taxStatus = false
        this.totalCount = 0
        this.discount = 0
        this.totalDiscount = 0
        this.totalTax = 0
        this.totalFee = 0
        this.sumRow = 0
        this.clearingStatus = false
        this.sum = 0
        this.totalDiscountType = false
        this.editCompositeTableData = []
        this.compositeTableData = []
        if (this.offline && !this.callInvoiceByNumber) {
          this.getInvoiceNumberOffline()
        } else {
          this.getInvoiceNumber()
        }
        if (!this.autoPrint) {
          this.account = null
        }
        this.addRow()
        this.$refs.form.resetValidation()
      },
      openCalculator () {
        const socket = new WebSocket('ws://localhost:4022/Tools')
        socket.onopen = function (event) {
          socket.send('calculator')
          // socket.close()
        }
        // socket.onmessage = function (event) {
        //   // document.getElementById('output').innerHTML += "<p>" + event.data + "</p>"
        // }
      },
      openWindowsKeyboard () {
        const socket = new WebSocket('ws://127.0.0.1:4022/Tools')
        console.log(socket)
        socket.onopen = function (event) {
          socket.send('keyboard')
          socket.close()
        }
      },
      sendToPos () {
        var app = this
        if (this.items.length === 0) return false
        if (!this.$refs.form.validate()) return false
        app.lodingText = app.$t('waitingTogetDataFromPOS')
        app.isLoading = true
        app.loadingDialog = true
        const socket = new WebSocket('ws://127.0.0.1:4022/PardakhtNovin_S800_Payment')
        socket.onopen = function (event) {
          socket.send(app.paymentAmount)
        }
        socket.onmessage = function (event) {
          var data = JSON.parse(event.data)
          if (data.ResponseCode !== '00') {
            app.isLoading = false
            app.lodingText = null
            app.loadingDialog = false
            app.snakbarText = data.description
            app.snakbarColor = 'pink'
            app.snakbar = true
          } else {
            app.paymentByPos = 'active'
            app.clearingStatus = true
            if (app.id) {
              app.update('print')
            } else {
              app.create('print')
            }
          }
          socket.close()
        }
      },
      print () {
          const socket = new WebSocket('ws://localhost:8145/Print')
          var app = this
          socket.onopen = function () {
            const selectedPrinter = "Microsoft Print to PDF"
            var body = app.$refs.refPrint.innerHTML
            var html = '<!DOCTYPE html><html><meta charset="utf-8"><head>' +
            '<style scoped>' +
            '  thead > tr > td{border: solid 1px #171717;padding: 5px;font-size: 9px}' +
            '  tbody > tr > td{border: solid 1px #171717;padding: 5px;font-size: 9px}' +
            '  tfoot > tr > td{border: solid 1px #171717;padding: 5px;font-size: 9px}' +
            '  body{font-family: "IRANSans(FaNum)";}}' +
            '@page {' +
            '    padding: 0mm;' +
            '    margin: 0mm;' +
            ' }' +
            ' @media print {' +
            '    margin: 0mm; padding: 0mm' +
            '}' +
            '' +
            '</style>' +
            '' +
            '</head>' +
            '<body style="width:100;direction: rtl">' + body +
            '</body>' +
            '</html>'
            socket.send(JSON.stringify({
              Key: "PRINTER",
              PrinterName: selectedPrinter,
              Data: html
            }))
          }
      }
    },
    beforeRouteLeave (to, from, next) {
      if (!this.nextPermission) {
        this.leavePage(to, from, next)
      } else {
        this.bottomNavigation = false
        next()
      }
    },
  }
</script>
<style scoped>
.v-application .overflow-y-auto {
  overflow-y: unset !important;
}
.fullscreen {
  position: fixed;
  top: 0px;
  z-index: 8;
  right: 0px;
}
.sum-td {
  text-align: center;
  font-size: 30px !important;
  color: white;
  background-color: #009688;
}
.fixed-bottom-payment {
  border-top: 1px solid silver;
}
.fixed-bottom-payment .wrapper-toggle-tax {
  border: 1px solid silver;
  border-radius: 4px;
}
.fixed-bottom-payment .wrapper-toggle-tax .child {
  padding: 7.5px;
  cursor: pointer;
}
.fixed-bottom-payment .wrapper-toggle-tax .child:first-child {
  border-left: 1px solid silver !important;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.fixed-bottom-payment .wrapper-toggle-tax .child:nth-child(2) {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.fixed-bottom-payment .header-total {
  border: 1.5px solid #0066ff;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  padding: 7px 10px;
}
.v-card__text {
  width: auto;
}
.fixed-bottom-payment .body-total {
  border: 1.5px solid silver;
  border-top: none;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
::v-deep .v-tabs--vertical > .v-window {
  margin-right: 30px;
}
.box {
  border: 1px solid silver;
  background-color: #f5f2f270;
  border-radius: 4px;
}
::v-deep .v-data-table.pos-table .v-data-table-header {
  background-color: #D9D9D9;
}
::v-deep .v-data-table.pos-table {
  border: 1px solid silver;
}
::v-deep .v-data-table.pos-table .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::v-deep .v-data-table.pos-table .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}
::v-deep .v-data-table.pos-table .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
::v-deep .v-data-table.pos-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 8.3pt;
  border-left: 1px solid silver !important;
  padding: 0 9px;
  color: black;
  height: 40px !important;
}
::v-deep .v-data-table.pos-table > .v-data-table__wrapper > table > thead > tr > th:first-child {
  border-top-right-radius: 4px;
}
::v-deep .v-data-table.pos-table > .v-data-table__wrapper > table > thead > tr > th:last-child {
  padding: 0 8px 0 4px;
  width: 30px;
  border-left: none;
  border-top-left-radius: 4px;
}
::v-deep .v-data-table.pos-table > .v-data-table__wrapper > table > tbody {
  position: relative;
}
::v-deep .v-data-table.pos-table > .v-data-table__wrapper > table > tbody > tr > td {
  border-left: 1px solid silver !important;
  padding-right: 10px;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:first-child:hover td:first-child {
  border-top-left-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:first-child:hover td:last-child {
  border-top-right-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:last-child {
  border-top: 1px solid silver;
  background-color: #f6f6f6;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:nth-last-child(2) {
  background-color: #f6f6f6;
}
::v-deep .v-data-table.pos-table > .v-data-table__wrapper > table > tbody > tr > td:last-child {
  width: 0;
  border-left: none;
  padding: 0 8px 0 3.6pt;
}
::v-deep .v-text-field--outlined .v-label {
  top: 6px !important; 
}
</style>
